import { forwardRef, type HTMLAttributes } from 'react';

import { cn } from '../lib/cn';
import { LAGEN } from '../lagen';

export type ToastVariant = 'default' | 'success' | 'destructive';

export interface ToastProps extends HTMLAttributes<HTMLLIElement> {
  variant?: ToastVariant;
}

const variants: Record<ToastVariant, string> = {
  default: 'border-[var(--border)] bg-[var(--background)] text-[var(--foreground)]',
  success: 'border-[var(--success)] bg-[var(--success-light)] text-[var(--foreground)]',
  destructive: 'border-[var(--destructive)] bg-[var(--destructive-light)] text-[var(--foreground)]',
};

export const Toast = forwardRef<HTMLLIElement, ToastProps>(function Toast(
  { className, variant = 'default', ...props },
  ref,
) {
  return <li className={cn('pointer-events-auto flex w-full items-start gap-3 rounded-[var(--radius-control)] border p-4 shadow-[var(--card-shadow)]', variants[variant], className)} ref={ref} {...props} />;
});

export const ToastTitle = forwardRef<HTMLParagraphElement, HTMLAttributes<HTMLParagraphElement>>(function ToastTitle(
  { className, ...props },
  ref,
) {
  return <p className={cn('text-sm font-semibold', className)} ref={ref} {...props} />;
});

export const ToastDescription = forwardRef<HTMLParagraphElement, HTMLAttributes<HTMLParagraphElement>>(function ToastDescription(
  { className, ...props },
  ref,
) {
  return <p className={cn('text-sm', className)} ref={ref} {...props} />;
});

export const ToastViewport = forwardRef<HTMLOListElement, HTMLAttributes<HTMLOListElement>>(function ToastViewport(
  { className, ...props },
  ref,
) {
  return <ol aria-atomic="true" aria-live="polite" className={cn('fixed right-4 top-4 grid w-full max-w-sm gap-2', LAGEN.melding, className)} ref={ref} {...props} />;
});
